import { __awaiter, __generator } from "tslib";
import { FileType } from '@office-start/document-types';
import { logFeature } from '@office-start/telemetry-service';
import { fetchUserEntitlements } from '@office-start/user-entitlements-service';
export function getLaunchInlineParams(document, context, capabilities, event) {
    return __awaiter(this, void 0, void 0, function () {
        var wacHostFile, fluidHostFile, openInNewTab, shouldHandleWacContent, oneDriveToken, identity, userEntitlements, hasOneDriveToken, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    wacHostFile = capabilities &&
                        document.fileType &&
                        !document.isLocalFile &&
                        !document.isEmailAttachment &&
                        capabilities.wacHostApps.has(document.fileType);
                    fluidHostFile = capabilities &&
                        capabilities.fluidSupportEnabled &&
                        document.fileType === FileType.Fluid;
                    openInNewTab = event && (event['ctrlKey'] || event['button'] === 1);
                    if (!capabilities.wacHostEnabled || !wacHostFile || openInNewTab) {
                        return [2 /*return*/, {
                                fluidHostFile: fluidHostFile,
                                oneDriveToken: undefined,
                                shouldHandleWacContent: false,
                            }];
                    }
                    shouldHandleWacContent = false;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, context.getIdentity()];
                case 2:
                    identity = _b.sent();
                    if (!!identity.isMsa) return [3 /*break*/, 5];
                    return [4 /*yield*/, fetchUserEntitlements()];
                case 3:
                    userEntitlements = (_b.sent()).result;
                    return [4 /*yield*/, context.getAccessToken('OneDrive', false, userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.OneDriveResourceId)];
                case 4:
                    oneDriveToken = _b.sent();
                    _b.label = 5;
                case 5:
                    hasOneDriveToken = oneDriveToken && !!oneDriveToken.token;
                    shouldHandleWacContent =
                        ((!document.isOnPremOrVanity || identity.isMsa) &&
                            hasOneDriveToken) ||
                            context.inMockMode;
                    return [3 /*break*/, 7];
                case 6:
                    _a = _b.sent();
                    logFeature({
                        featureName: "LauncherService" /* KnownFeatureNames.LauncherService */,
                        eventName: 'LaunchInlineParamsException',
                        params: {
                            Message: 'Unable to fetch identity or access token',
                            DebugInfo: "identity:".concat(!!identity, ",oneDriveToken:").concat(!!oneDriveToken),
                        },
                    });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, {
                        fluidHostFile: fluidHostFile,
                        oneDriveToken: oneDriveToken,
                        shouldHandleWacContent: shouldHandleWacContent,
                    }];
            }
        });
    });
}
//# sourceMappingURL=getLaunchInlineParams.js.map